module.exports = __webpack_public_path__ + "media/introduction/Learn_Icon-24be1a2a.svg";